(() => {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const jump = el => { el?.scrollIntoView({behavior: reduced ? 'auto' : 'smooth', block:'center'}); };
    const films = [...root.querySelectorAll('[data-hx-film]')];
    const video = root.querySelector('.hx-cinema video');
    films.forEach(button => button.addEventListener('click', () => {
      video.pause();
      films.forEach(item => { item.classList.toggle('is-active', item === button); item.setAttribute('aria-pressed', String(item === button)); });
      video.poster = button.dataset.hxPoster;
      video.src = button.dataset.hxFilm;
      video.load();
      root.querySelector('.hx-cinema__status').textContent = 'Selected: ' + button.querySelector('b').textContent + '. Press play to watch.';
    }));
    const pointButtons = [...root.querySelectorAll('[data-hx-point]')];
    pointButtons.forEach(button => button.addEventListener('click', () => {
      pointButtons.forEach(item => { const on = item.dataset.hxPoint === button.dataset.hxPoint; item.setAttribute('aria-pressed', String(on)); item.classList.toggle('is-active', on); });
      root.querySelectorAll('[data-hx-point-panel]').forEach(panel => { panel.hidden = panel.dataset.hxPointPanel !== button.dataset.hxPoint; });
    }));
    const concept = root.querySelector('[data-hx-concept]');
    const word = root.querySelector('#hx-word');
    const state = {palette:'mint', style:'orbit'};
    word.addEventListener('input', () => { root.querySelector('[data-hx-concept-text]').textContent = word.value.trim() || 'YOUR IDEA'; });
    const palettes = {mint:'#adfbef', violet:'#c4a4ff', amber:'#ffcb75'};
    root.querySelectorAll('[data-hx-palette]').forEach(button => button.addEventListener('click', () => {
      state.palette = button.dataset.hxPalette;
      concept.style.setProperty('--concept', palettes[state.palette]);
      root.querySelectorAll('[data-hx-palette]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    }));
    root.querySelectorAll('[data-hx-style]').forEach(button => button.addEventListener('click', () => {
      state.style = button.dataset.hxStyle; concept.dataset.style = state.style;
      root.querySelectorAll('[data-hx-style]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    }));
    root.querySelector('[data-hx-brief]').addEventListener('click', () => {
      const message = root.querySelector('#hx-message');
      message.value = `I'm interested in ${root.dataset.model}.\nContent concept: ${word.value.trim() || 'YOUR IDEA'}\nPalette: ${state.palette}\nVisual direction: ${state.style}\nQuantity:\nDelivery country / region:\nIntended use:\n\nPlease help confirm the hardware and content requirements.`;
      jump(message); message.focus({preventScroll:true});
    });
    root.querySelector('[data-hx-download]').addEventListener('click', () => {
      const rows = [...root.querySelectorAll('.hx-spec-grid dl>div')].map(row => row.querySelector('dt').textContent + ': ' + row.querySelector('dd').textContent);
      const note = root.querySelector('.hx-config-note').innerText;
      const blob = new Blob([`HoloVista 3D — ${root.dataset.model}\nSupplier consumer catalog specifications\n\n${rows.join('\n')}\n\n${note}\n\nProduct: ${location.origin + location.pathname}\nContact: ${location.origin}/pages/contact\n`], {type:'text/plain;charset=utf-8'});
      const url = URL.createObjectURL(blob); const link = document.createElement('a');
      link.href = url; link.download = `HoloVista-${root.dataset.model}-catalog-specifications.txt`; link.click();
      setTimeout(() => URL.revokeObjectURL(url), 3000);
    });
    const purchase = document.querySelector('.product-form__submit');
    root.querySelectorAll('[data-hx-buy]').forEach(button => button.addEventListener('click', () => { jump(purchase); purchase?.focus({preventScroll:true}); }));
    const bar = root.querySelector('.hx-purchase-bar');
    let inside = false, purchaseVisible = true, footerVisible = false, editing = false;
    const update = () => { bar.hidden = !inside || purchaseVisible || footerVisible || editing; };
    root.addEventListener('focusin', event => { editing = event.target.matches('input, textarea'); update(); });
    root.addEventListener('focusout', () => { editing = false; update(); });
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === root) inside = entry.isIntersecting;
        if (entry.target === purchase) purchaseVisible = entry.isIntersecting;
        if (entry.target.matches('footer')) footerVisible = entry.isIntersecting;
      }); update();
    }, {threshold:0});
    observer.observe(root); if (purchase) observer.observe(purchase);
    const footer = document.querySelector('footer'); if (footer) observer.observe(footer);
    const videoObserver = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) video.pause(); }, {threshold:0});
    videoObserver.observe(video);
    document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); });
  }
  document.querySelectorAll('[data-hx]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-hx]').forEach(init));
})();
